import Uploader, { FirebaseImage } from "@/controller/uploader";
import Auth from "@/controller/auth";

const userPhone = Auth.getUserUid() as string;

export default function useUpload() {
  async function uploadSkinProfileImage(file: File): Promise<FirebaseImage> {
    return Uploader.uploadSkinProfileImage(userPhone, file);
  }

  return {
    uploadSkinProfileImage
  };
}
